"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.PhoneVerificationOrigin=void 0;var o;(function(e){e.Checkout="checkout",e.IdentityFlow="identity_flow",e.Login="login",e.Profile="profile"})(o||(exports.PhoneVerificationOrigin=o={}));
//# sourceMappingURL=PhoneVerificationOrigin.js.map
